<template>
  
    <div class="land-supply-page">
      <div class="container">
        <div class="form-wrapper">
          <!-- <h2 class="form-title">发布土方信息</h2> -->
          <div class="draft-toggle">
              <div class="draft-link-group" v-if="val === '0' || val === 0">
                <div style="display: flex; gap: 10px; align-items: center;">
                  <label class="radio-option">
                    <input 
                      type="radio" 
                      name="infoType" 
                      value="1"
                      v-model="infoType"
                      required
                      @change="showInfoTypeError = false"
                    />
                    <span class="radio-label">找土</span>
                  </label>
                  <label class="radio-option">
                    <input 
                      type="radio" 
                      name="infoType" 
                      value="0"
                      v-model="infoType"
                      required
                      @change="showInfoTypeError = false"
                    />
                    <span class="radio-label">弃土</span>
                  </label>
                </div>
                <div v-if="showInfoTypeError" class="error-message">请选择信息类型（找土或弃土）</div>
              </div>
            <span 
              class="draft-link" 
              @click="toggleDraftList"
              :class="{ active: showDraftList }"
            >
              <i class="iconfont icon-list"></i> 暂存列表<span style="font-size: 12px;">（只能暂存24小时，之后信息会被清除）</span>
              <span class="draft-count">({{ draftList ? draftList.length : 0 }})</span>
            </span>
          </div>
          <!-- 所在地区 -->
          <div class="form-group">
            <label class="form-label"><span class="required">*</span>所在县区</label>
            <div class="form-control">
              <div class="region-selector">
                <div class="filter-item">
                  <span 
                    class="filter-label"
                    @mouseenter="showRegionDropdown = true"
                  >
                    <span class="current-value">{{ formData.region || '请选择地区' }}</span>
                    <span class="iconfont icon-xiangyou3" style="font-size: 12px; margin-left: 5px;"></span>
                  </span>
                  <div 
                    class="filter-dropdown" 
                    v-show="showRegionDropdown"
                    @mouseenter="showRegionDropdown = true"
                    @mouseleave="showRegionDropdown = false"
                  >
                    <span 
                      v-for="region in regionOptions" 
                      :key="region"
                      :class="['filter-option', { active: formData.region === region }]"
                      @click="handleRegionSelect(region)"
                    >
                      {{ region }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 详细地址 -->
          <div class="form-group">
            <label class="form-label">详细地址</label>
            <div class="form-control">
              <input 
                v-model="formData.detailAddress" 
                type="text" 
                placeholder="请输入详细地址" 
                class="input-text full-width"
              />
            </div>
          </div>

          <!-- 地图标主 -->
          <div class="form-group">
            <label class="form-label">地图标注</label>
            <div class="form-control map-control">
              <input 
                v-model="formData.mapLocation" 
                type="text" 
                placeholder="请输入土方位置" 
                class="input-text"
              />
              <button type="button" class="mark-btn" @click="showMapModal">
                <i class="iconfont icon-location"></i> 标记坐标
              </button>
            </div>
          </div>

          <!-- 地图显示区域 -->
          <div v-if="formData.mapLocation" class="form-group">
            <label class="form-label">位置预览</label>
            <div class="form-control">
              <div id="amap-display-container" class="amap-display-container"></div>
            </div>
          </div>

          <!-- 土方类型（单选下拉） -->
          <div class="form-group">
            <label class="form-label">土方类型</label>
            <div class="form-control">
              <div class="region-selector">
                <div class="filter-item">
                  <span 
                    class="filter-label"
                    @mouseenter="showSoilTypeDropdown = true"
                  >
                    <span class="current-value">{{ formData.soilType || '请选择土方类型' }}</span>
                    <span class="iconfont icon-xiangyou3" style="font-size: 12px; margin-left: 5px;"></span>
                  </span>
                  <div 
                    class="filter-dropdown" 
                    v-show="showSoilTypeDropdown"
                    @mouseenter="showSoilTypeDropdown = true"
                    @mouseleave="showSoilTypeDropdown = false"
                  >
                    <span 
                      v-for="opt in soilTypeOptions" 
                      :key="opt"
                      :class="['filter-option', { active: formData.soilType === opt }]"
                      @click="handleSoilTypeSelect(opt)"
                    >
                      {{ opt }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 社会统一代码与项目信息 -->
          <div class="form-group-row">
            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>社会统一代码</label>
              <div class="form-control">
                <input
                  v-model="formData.creditCode"
                  type="text"
                  placeholder="请输入统一社会信用代码"
                  class="input-text full-width"
                />
              </div>
            </div>
            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>项目代码</label>
              <div class="form-control">
                <input
                  v-model="formData.projectCode"
                  type="text"
                  placeholder="请输入项目代码"
                  class="input-text full-width"
                />
              </div>
            </div>
          </div>
          <div class="form-group-row">
            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>建设单位名称</label>
              <div class="form-control">
                <input
                  v-model="formData.companyName"
                  type="text"
                  placeholder="请输入建设单位名称"
                  class="input-text full-width"
                />
              </div>
            </div>
            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>项目名称</label>
              <div class="form-control">
                <input
                  v-model="formData.projectName"
                  type="text"
                  placeholder="请输入项目名称"
                  class="input-text full-width"
                />
              </div>
            </div>
          </div>

          <!-- 主地体积 -->
          <div class="form-group">
            <label class="form-label"><span class="required">*</span>土方体积</label>
            <div class="form-control area-control">
              <input 
                v-model="formData.area" 
                type="number" 
                placeholder="请输入体积" 
                class="input-text area-input"
              />
              <span class="input-select unit-select unit-fixed" aria-hidden="true">万m³</span>
            </div>
          </div>

          <!-- 信息标题 -->
          <div class="form-group">
            <label class="form-label"><span class="required">*</span>标题信息</label>
            <div class="form-control">
              <input 
                v-model="formData.title" 
                type="text" 
                placeholder="如：多少方，工期等" 
                class="input-text full-width"
              />
            </div>
          </div>

          <!-- 土详细 -->
          <div class="form-group">
            <label class="form-label"><span class="required">*</span>补充其他信息</label>
            <div class="form-control">
              <textarea 
                v-model="formData.description" 
                placeholder="可输入土方状况、位置、交通运输等信息"
                class="input-textarea"
                rows="6"
              ></textarea>
           
            </div>
          </div>

          <!-- 土联系人和联系人电话 -->
          <div class="form-group-row">
            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>联系人</label>
              <div class="form-control">
                <input 
                  v-model="formData.contactName" 
                  type="text" 
                  placeholder="请输入联系人姓名" 
                  class="input-text full-width"
                />
              </div>
            </div>

            <div class="form-group-item">
              <label class="form-label"><span class="required">*</span>联系人电话</label>
              <div class="form-control">
                <input 
                  v-model="formData.contactPhone" 
                  type="tel" 
                  placeholder="请输入联系电话" 
                  class="input-text full-width"
                />
              </div>
            </div>
          </div>

          <!-- 时间区间（与联系人行同布局，保证输入框左右对齐） -->
          <div class="form-group-row time-range-group">
            <div class="form-group-item">
              <label class="form-label">预计开工时间</label>
              <div class="form-control">
                <input 
                  v-model="formData.startTime" 
                  type="month" 
                  class="input-text full-width datetime-input"
                  placeholder="选择年月"
                />
              </div>
            </div>
            <div class="form-group-item">
              <label class="form-label">预计完工时间</label>
              <div class="form-control">
                <input 
                  v-model="formData.endTime" 
                  type="month" 
                  class="input-text full-width datetime-input"
                  placeholder="选择年月"
                />
              </div>
            </div>
          </div>


         

          <!-- 金额 -->
          <!-- <div class="form-group">
            <label class="form-label"><span class="required">*</span>金额</label>
            <div class="form-control price-control">
              <input 
                v-model="formData.price" 
                type="number" 
                placeholder="输入土地价格" 
                class="input-text price-input"
              />
              <select v-model="formData.priceUnit" class="input-select unit-select">
                <option value="元/吨">元/吨</option>
                <option value="元/立方米">元/立方米</option>
                <option value="万元">万元</option>
                <option value="元/立方">元/立方</option>
              </select>
            </div>
          </div> -->

         

          <!-- 上传土方图片 -->
          <div class="form-group">
            <label class="form-label">上传土方图片</label>
            <div class="form-control">
              <div class="upload-area" @click="triggerFileInput">
                <input 
                  ref="fileInput"
                  type="file" 
                  accept="image/jpeg,image/jpg,image/png,image/gif"
                  multiple
                  style="display: none"
                  @change="handleFileChange"
                />
                <div v-if="formData.images.length === 0" class="upload-placeholder">
                  <i class="iconfont icon-image"></i>
                  <p>请选择图片</p>
                </div>
                <div v-else class="image-preview-list">
                  <div v-if="formData.images.length < 9" class="add-more-btn" @click.stop="triggerFileInput">
                    <i class="iconfont icon-add"></i>
                  </div>
                  <div v-for="(image, index) in formData.images" :key="index" class="image-preview-item">
                    <img :src="getImageUrl(image)" alt="土方图片" @error="handleImageError($event, index)" />
                    <button type="button" class="remove-image-btn" @click.stop="removeImage(index)">
                      <span class="close-icon">×</span>
                    </button>
                  </div>
                  
                </div>
              </div>
              <p class="upload-tip">单张最大6M,最多上传6张，支持：JPG/JPEG/GIF/PNG 格式</p>
            </div>
          </div>

          

          

          

          <!-- 提交按钮 -->
          <div class="form-actions">
            <button type="button" class="submit-btn" @click="submitForm">提交发布</button>
            <button type="button" class="submit-btn1" @click="saveDraft">暂存</button>
            <button type="button" class="cancel-btn" @click="resetForm">重置</button>
          </div>

        </div>
      </div>
    </div>

    <!-- 暂存列表弹窗 -->
    <div v-if="showDraftList" class="draft-modal" @click.self="closeDraftModal">
      <div class="draft-modal-container">
        <div class="draft-modal-header">
          <h3>暂存列表</h3>
          <button class="close-btn" @click="closeDraftModal">×</button>
        </div>
        
        <div class="draft-modal-controls">
          <div class="draft-controls">
            <!-- <select v-model="draftSortBy" class="sort-select" @change="sortDrafts">
              <option value="time-desc">按时间降序</option>
              <option value="time-asc">按时间升序</option>
              <option value="title-asc">按标题A-Z</option>
              <option value="title-desc">按标题Z-A</option>
            </select> -->
            <input 
              v-model="draftSearchKeyword" 
              type="text" 
              placeholder="搜索标题..." 
              class="search-input"
              @input="filterDrafts"
            />
          </div>
        </div>
        
        <div class="draft-modal-content">
          <div v-if="safeFilteredDrafts.length === 0" class="empty-state">
            <i class="iconfont icon-empty"></i>
            <p>暂无暂存信息</p>
          </div>
          <div v-else class="draft-items">
            <div 
              v-for="(draft, index) in safeFilteredDrafts" 
              :key="draft.id" 
              class="draft-item"
              :class="{ selected: selectedDraftId === draft.id }"
             
            >
              <!-- 序号 -->
              <div class="draft-index">{{ index + 1 }}</div>
              <!-- <div class="draft-radio">
                <input 
                  type="radio" 
                  :id="'draft-' + draft.id"
                  :value="draft.id"
                  v-model="selectedDraftId"
                  @click.stop
                />
                <label :for="'draft-' + draft.id"></label>
              </div> -->
              <div class="draft-content">
                <h4 class="draft-title">{{ draft.title || '未命名信息' }}</h4>
                <div class="draft-meta">
                  <span class="draft-region">{{ draft.region || '未选择地区' }}</span>
                  <span class="draft-area">{{ draft.area }}{{ draft.areaUnit }}</span>
                  <span class="draft-time">{{ draft.createTime }}</span>
                </div>
                <p class="draft-description">{{ draft.description || '暂无描述' }}</p>
              </div>
              <div class="draft-actions">
                <button class="action-btn edit-btn" @click.stop="editDraft(draft)">
                  <i class="iconfont icon-bianji"></i>
                </button>
                <button class="action-btn delete-btn" @click.stop="deleteDraft(draft.id)">
                  <i class="iconfont icon-shanchu"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="selectedDraftId" class="draft-modal-footer">
          <button class="load-btn" @click="loadDraftToForm">
            <i class="iconfont icon-load"></i> 加载到表单
          </button>
        </div>
      </div>
    </div>

    <!-- 地图模态框 -->
    <div v-if="showMap" class="map-modal" @click.self="closeMapModal">
      <div class="map-container">
        <div class="map-header">
          <h3>选择土方位置</h3>
          <button class="close-btn" @click="closeMapModal">×</button>
        </div>
        
        <div class="map-content">
          <div id="amap-container-supply" class="amap-container"></div>
        </div>
        
        <div class="map-actions">
          <button 
            class="confirm-btn" 
            @click="confirmLocationSelection"
            :disabled="!formData.mapLocation"
          >
            确认选择
          </button>
        </div>
      </div>
    </div>

</template>

<script>
  /* global AMap */
  import { addSoilInfo, uploadFile, updateSoilInfo, getMySoilInfoList, removeSoilInfo } from '@/api/user'
export default {
    name: 'QiList',
    props: {
      val: {
        type: [String, Number],
        default: '0'
      },
      initialFormData: {
        type: Object,
        default: () => ({})
      },
      editId: {
        type: [String, Number],
        default: null
      }
    },
    data() {
      return {
      // 表单数据
      formData: {
        region: '',
        mapLocation: '',
        detailAddress: '',
        startTime: '',
        endTime: '',
        soilType: '',
        area: '',
        areaUnit: '万m³',
        transferType: '经营权出租',
        price: '',
        priceUnit: '元/立方/年',
        years: '',
        images: [],
        title: '',
        description: '',
        contactName: '',
        contactPhone: '',
        creditCode: '',
        projectCode: '',
        companyName: '',
        projectName: ''
      },
      // 发布类型：infoType（0=弃土，1=找土）
      infoType: '',
      showInfoTypeError: false,
      // 暂存列表相关
      showDraftList: false,
      draftList: [],
      filteredDrafts: [],
      selectedDraftId: null,
      draftSortBy: 'time-desc',
      draftSearchKeyword: '',
      draftLoadedId: null, // 从暂存列表加载到表单的 id
      // 地区选项
      regionOptions: [ '海港区', '开发区', '抚宁区','北戴河区','北戴河新区',
      '山海关区', '青龙县', '卢龙县', '昌黎县'],
      showRegionDropdown: false,
      // 土方类型
      soilTypeOptions: ['表土','松软土','普通土','坚土','砂砾坚土','软石','次坚石','坚石','特坚石','回填土','外运土方','借方土','常规土方','特殊土方'],
      showSoilTypeDropdown: false,
      // 流转类型选项
      transferTypes: [
        { label: '经营权出租', value: '经营权出租' },
        { label: '经营权转包', value: '经营权转包' },
        { label: '经营权合作', value: '经营权合作' },
        { label: '经营权入股', value: '经营权入股' },
        { label: '经营权转让', value: '经营权转让' },
        { label: '经营权互换', value: '经营权互换' }
      ],
      searchKeyword: '',
      selectedFilter: 'newest',
      selectedType: '',
      selectedRegion: '',
      selectedMore: '',
      showMap: false,
      mapLocation: '',
      selectedDistance: '5',
      mapResults: [],
      map: null,
      
      clickMarker: null,
      mapCenter: { lng: 119.6, lat: 39.9 },
      searchCircle: null, // 搜索范围圆圈
      displayMap: null, // 表单显示地图实例
      displayMarker: null, // 表单显示地图标记
        landList: [
          {
            image: require('@/assets/sjt/1.png'),
            title: '秦皇岛抚宁区8.91立方仓储用土使用权转让',
            tags: ['仓储用土', '使用权转让'],
            description: '8.91立方/44年/秦皇岛抚宁区',
            price: '¥800万元',
            isVideo: true,
            type: 'supply'
          },
          {
            image: require('@/assets/sjt/2.png'),
            title: '秦皇岛卢龙县110.91立方果园经营权出租',
            tags: ['果园', '经营权出租'],
            description: '110.91立方/20年/秦皇岛卢龙县',
            price: '¥180万元',
            isVideo: false,
            type: 'supply'
          },
          {
            image: require('@/assets/sjt/3.png'),
            title: '秦皇岛抚宁区230.07立方其它林地经营权出租',
            tags: ['其它林地', '经营权出租'],
            description: '230.07立方/10年/秦皇岛抚宁区',
            price: '¥1000元/立方/年',
            isVideo: false,
            type: 'supply'
          },
          {
            image: require('@/assets/sjt/4.png'),
            title: '秦皇岛海港区15.5立方工业用土使用权转让',
            tags: ['工业用土', '使用权转让'],
            description: '15.5立方/50年/秦皇岛海港区',
            price: '¥1200万元',
            isVideo: false,
            type: 'supply'
          },
          {
            image: require('@/assets/sjt/5.png'),
            title: '秦皇岛开发区25.8立方商服用土使用权转让',
            tags: ['商服用土', '使用权转让'],
            description: '25.8立方/40年/秦皇岛开发区',
            price: '¥2000万元',
            isVideo: true,
            type: 'supply'
          }
        ]
      }
  },
  computed: {
    safeFilteredDrafts() {
      return this.filteredDrafts || [];
    }
  },
 
  watch: {
    // 监听 initialFormData 变化，填充表单（用于弹窗场景）
    initialFormData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log('watch initialFormData 变化:', newVal);
          this.fillFormFromInitialData(newVal);
          console.log('watch 填充后的 formData.images:', this.formData.images);
        }
      },
      deep: true,
      immediate: false
    },
    // 监听地图位置变化
    'formData.mapLocation': {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initDisplayMap();
          });
        } else {
          // 如果坐标被清空，清理显示地图
          if (this.displayMap) {
            this.displayMap.destroy();
            this.displayMap = null;
            this.displayMarker = null;
          }
        }
      }
    }
  },
  mounted() {
    // 首先根据 val prop 设置 infoType 默认值（从找土/弃土页面跳转时）
    // 统一处理 val 的类型（可能是字符串或数字）
    const valStr = String(this.val);
    if (valStr === '1') {
      this.infoType = '1'; // 找土
    } else if (valStr === '2') {
      this.infoType = '0'; // 弃土
    }
    // val === '0' 时，显示单选按钮让用户选择，不设置默认值
    
    // 然后从路由参数获取 infoType（从路由跳转时传递，会覆盖默认值）
    if (this.$route && this.$route.query && this.$route.query.infoType) {
      this.infoType = String(this.$route.query.infoType);
    }
    
    // 最后从 props 获取初始数据（从首页弹窗传递，会覆盖默认值）
    if (this.initialFormData && Object.keys(this.initialFormData).length > 0) {
      console.log('发布组件初始化 - 接收到 initialFormData:', this.initialFormData);
      this.fillFormFromInitialData(this.initialFormData);
      console.log('发布组件初始化 - 填充后的 formData.images:', this.formData.images);
    }
    
    console.log('发布组件初始化 - val:', this.val, 'valStr:', valStr, 'infoType:', this.infoType);
    
    // 从路由参数获取其他表单字段并填充（兼容路由跳转）
    if (this.$route && this.$route.query) {
      if (this.$route.query.region) {
        // 验证地区是否在选项列表中
        if (this.regionOptions.includes(this.$route.query.region)) {
          this.formData.region = this.$route.query.region;
        }
      }
      
      if (this.$route.query.soilType) {
        // 验证土方类型是否在选项列表中
        if (this.soilTypeOptions.includes(this.$route.query.soilType)) {
          this.formData.soilType = this.$route.query.soilType;
        }
      }
    }
   
    // 动态加载高德地图API
    this.loadAmapScript();
    // 加载暂存列表
    this.loadDraftList();
  },
  beforeUnmount() {
    // 清理地图实例
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
    if (this.displayMap) {
      this.displayMap.destroy();
      this.displayMap = null;
    }
  },
  methods: {
    // 根据初始数据填充表单
    fillFormFromInitialData(initialData) {
      console.log('填充表单数据:', initialData);
      
      // 填充信息类型（只有当 initialData.infoType 有明确值时才覆盖，否则保持 val 设置的默认值）
      if (initialData.infoType !== undefined && initialData.infoType !== null && initialData.infoType !== '') {
        this.infoType = String(initialData.infoType);
      }
      
      // 填充地区
      if (initialData.region) {
        // 验证地区是否在选项列表中
        if (this.regionOptions.includes(initialData.region)) {
          this.formData.region = initialData.region;
        }
      }
      
      // 填充土方类型
      if (initialData.soilType) {
        // 验证土方类型是否在选项列表中
        if (this.soilTypeOptions.includes(initialData.soilType)) {
          this.formData.soilType = initialData.soilType;
        }
      }
      
      // 填充地图位置（坐标）
      if (initialData.mapLocation) {
        this.formData.mapLocation = initialData.mapLocation;
        // 解析坐标并设置地图中心
        const coords = initialData.mapLocation.split(',').map(c => parseFloat(c.trim()));
        if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          this.mapCenter = { lng: coords[0], lat: coords[1] };
        }
      }
      
      // 填充详细地址
      if (initialData.detailAddress) {
        this.formData.detailAddress = initialData.detailAddress;
      }
      
      // 填充开始/结束时间（仅年月 YYYY-MM；兼容旧数据 YYYY-MM-DD）
      if (initialData.startTime) {
        this.formData.startTime = this.normalizeMonthValue(initialData.startTime);
      }
      
      if (initialData.endTime) {
        this.formData.endTime = this.normalizeMonthValue(initialData.endTime);
      }
      
      // 填充面积
      if (initialData.area) {
        this.formData.area = initialData.area;
      }
      
      // 体积单位固定为万m³
      this.formData.areaUnit = '万m³';
      
      // 填充流转类型
      if (initialData.transferType) {
        this.formData.transferType = initialData.transferType;
      }
      
      // 填充价格
      if (initialData.price) {
        this.formData.price = initialData.price;
      }
      
      // 填充价格单位
      if (initialData.priceUnit) {
        this.formData.priceUnit = initialData.priceUnit;
      }
      
      // 填充年限
      if (initialData.years) {
        this.formData.years = initialData.years;
      }
      
      // 填充图片
      if (initialData.images && Array.isArray(initialData.images)) {
        console.log('填充图片数据:', initialData.images);
        this.formData.images = initialData.images.map(img => {
          // 如果已经是对象格式，处理URL
          if (typeof img === 'object' && img.url) {
            console.log('使用已有图片对象:', img);
            // 确保 url 是完整的可访问URL
            let fullUrl = img.url;
            if (fullUrl && !fullUrl.startsWith('http') && !fullUrl.startsWith('data:')) {
              // 如果 url 不是完整URL，尝试拼接
              if (fullUrl.startsWith('/upload/')) {
                // 去掉开头的 /upload，然后拼接 /upload/qtzp/
                const pathAfterUpload = fullUrl.replace(/^\/upload\//, '');
                fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload/${pathAfterUpload}`;
              } else if (fullUrl.startsWith('/')) {
                fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload${fullUrl}`;
              } else {
                fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload/${fullUrl}`;
              }
            }
            // 返回新对象，不修改原对象
            return {
              ...img,
              url: fullUrl
            };
          }
          // 如果是字符串，转换为对象格式
          let fullUrl = img;
          let fileName = img;
          if (!img.startsWith('http') && !img.startsWith('data:')) {
            if (img.startsWith('/upload/')) {
              // 去掉开头的 /upload，然后拼接 /upload/qtzp/
              const pathAfterUpload = img.replace(/^\/upload\//, '');
              fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload/${pathAfterUpload}`;
              fileName = img; // 保持完整相对路径
            } else if (img.startsWith('/')) {
              fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload${img}`;
              fileName = img; // 保持完整相对路径
            } else {
              fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload/${img}`;
              fileName = img;
            }
          } else {
            // 如果是完整URL，提取路径作为fileName
            try {
              const urlObj = new URL(img);
              fileName = urlObj.pathname;
            } catch (e) {
              fileName = img;
            }
          }
          return {
            url: fullUrl,
            fileName: fileName
          };
        });
        console.log('填充后的图片数据:', this.formData.images);
      }
      
      // 填充标题
      if (initialData.title) {
        this.formData.title = initialData.title;
      }
      
      // 填充描述
      if (initialData.description) {
        this.formData.description = initialData.description;
      }
      
      // 填充联系人
      if (initialData.contactName) {
        this.formData.contactName = initialData.contactName;
      }
      
      // 填充联系电话
      if (initialData.contactPhone) {
        this.formData.contactPhone = initialData.contactPhone;
      }
      
      // 填充应用场景
      if (initialData.application) {
        this.formData.application = initialData.application;
      }

      if (initialData.creditCode != null && initialData.creditCode !== '') {
        this.formData.creditCode = initialData.creditCode;
      }
      if (initialData.projectCode != null && initialData.projectCode !== '') {
        this.formData.projectCode = initialData.projectCode;
      }
      if (initialData.companyName != null && initialData.companyName !== '') {
        this.formData.companyName = initialData.companyName;
      }
      if (initialData.projectName != null && initialData.projectName !== '') {
        this.formData.projectName = initialData.projectName;
      }
      
      // 如果有地图位置，初始化显示地图
      if (this.formData.mapLocation) {
        this.$nextTick(() => {
          this.initDisplayMap();
        });
      }
    },
    handleRegionSelect(region) {
      this.formData.region = region;
      this.showRegionDropdown = false;
    },
    handleSoilTypeSelect(opt) {
      this.formData.soilType = opt;
      this.showSoilTypeDropdown = false;
    },
    loadAmapScript() {
      const plugins = ['AMap.Geolocation', 'AMap.Scale', 'AMap.ToolBar'];
      const ensurePlugins = () =>
        new Promise((resolve, reject) => {
          if (!window.AMap) {
            reject(new Error('高德地图 API 未就绪'));
            return;
          }
          // 即使主脚本已缓存，也必须执行 plugin 回调后 Geolocation 等才是可用构造函数
          AMap.plugin(plugins, () => {
            resolve();
          });
        });

      return new Promise((resolve, reject) => {
        if (window.AMap) {
          ensurePlugins().then(resolve).catch(reject);
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://webapi.amap.com/maps?v=2.0&key=6c995fc229d0e1ad8fa3f066161ee70a';
        script.onload = () => {
          console.log('高德地图API加载完成');
          ensurePlugins().then(resolve).catch(reject);
        };
        script.onerror = () => reject(new Error('高德地图脚本加载失败'));
        document.head.appendChild(script);
      });
    },
    performSearch() {
      console.log('搜索关键词:', this.searchKeyword);
      // 这里可以添加搜索逻辑
    },
    async showMapModal() {
      this.showMap = true;
      try {
        await this.loadAmapScript();
        this.$nextTick(() => {
          this.initAmap();
        });
      } catch (error) {
        console.error('地图加载失败:', error);
      }
    },
    initAmap() {
      if (!window.AMap) {
        console.error('高德地图API未加载');
        return;
      }

      // 初始化地图
      this.map = new AMap.Map('amap-container-supply', {
        zoom: 11,
        center: [119.6, 39.9], // 秦皇岛市中心坐标
        mapStyle: 'amap://styles/normal'
      });

      // 添加点击事件
      this.map.on('click', (e) => {
        this.handleMapClick(e);
      });

      // 添加定位控件（依赖 AMap.plugin 预加载，否则跳过以免整图崩溃）
      if (typeof AMap.Geolocation === 'function') {
        this.map.addControl(new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
          convert: true,
          showButton: true,
          buttonPosition: 'LB',
          showMarker: true,
          showCircle: true,
          panToLocation: true,
          zoomToAccuracy: true
        }));
      } else {
        console.warn('AMap.Geolocation 未就绪，已跳过定位控件');
      }

      if (typeof AMap.Scale === 'function') {
        this.map.addControl(new AMap.Scale());
      }
      if (typeof AMap.ToolBar === 'function') {
        this.map.addControl(new AMap.ToolBar());
      }
    },
    handleMapClick(e) {
      const { lng, lat } = e.lnglat;
      console.log('地图点击位置:', lng, lat);
      
      // 清除之前的标记
      if (this.clickMarker) {
        this.map.remove(this.clickMarker);
      }
      
      // 创建自定义标记内容（使用icon-1图标）
      const markerContent = document.createElement('div');
      markerContent.className = 'custom-marker';
      markerContent.innerHTML = '<i class="iconfont icon-1" style="font-size: 48px; color: #FF0000; text-shadow: 0 3px 6px rgba(255, 0, 0, 0.4); display: block; line-height: 1;"></i>';
      
      // 添加点击标记
      this.clickMarker = new AMap.Marker({
        position: [lng, lat],
        content: markerContent,
        offset: new AMap.Pixel(-24, -48),
        title: '选择的位置'
      });
      this.map.add(this.clickMarker);
      
      // 保存坐标到formData.mapLocation
      this.formData.mapLocation = `${lng.toFixed(6)}, ${lat.toFixed(6)}`;
      
      // 更新搜索中心点
      this.mapCenter = { lng, lat };
    },
    closeMapModal() {
      this.showMap = false;
      
      // 清理标记
      if (this.clickMarker) {
        this.clickMarker = null;
      }
      
      // 清理地图实例
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },
    confirmLocationSelection() {
      if (this.formData.mapLocation) {
        console.log('已选择位置:', this.formData.mapLocation);
        this.closeMapModal();
      }
    },
    searchLocation() {
      if (this.mapLocation.trim()) {
        console.log('搜索位置:', this.mapLocation);
        this.generateMapResults();
      }
    },
    updateMapRadius() {
      console.log('更新搜索范围:', this.selectedDistance + '公里');
      this.generateMapResults();
      
      // 根据搜索范围调整地图缩放级别
      if (this.map) {
        const distance = parseInt(this.selectedDistance);
        let zoomLevel;
        
        // 5,11 10,10 20,9
        if (distance <= 5) {
          zoomLevel = 11;
        } else if (distance <= 10) {
          zoomLevel = 10;
        } else if (distance <= 20) {
          zoomLevel = 9;
        }
        
        this.map.setZoom(zoomLevel);
        console.log('地图缩放级别调整为:', zoomLevel);
        
        // 更新搜索范围圆圈
        this.updateSearchCircle();
      }
    },
    updateSearchCircle() {
      if (!this.map || !this.mapCenter) return;
      
      // 清除之前的圆圈
      if (this.searchCircle) {
        this.map.remove(this.searchCircle);
      }
      
      // 创建新的搜索范围圆圈
      const radius = parseInt(this.selectedDistance) * 1000; // 转换为米
      this.searchCircle = new AMap.Circle({
        center: [this.mapCenter.lng, this.mapCenter.lat],
        radius: radius,
        strokeColor: '#0d6a57',
        strokeWeight: 2,
        strokeOpacity: 0.8,
        fillColor: '#0d6a57',
        fillOpacity: 0.1
      });
      
      this.map.add(this.searchCircle);
    },
    generateMapResults() {
      // 模拟土方供应数据（包含真实坐标）
      const landData = [
        {
          title: '秦皇岛抚宁区仓储用土供应',
          description: '8.91立方/44年/抚宁区',
          price: '¥800万元',
          lng: 119.2,
          lat: 40.0
        },
        {
          title: '秦皇岛卢龙县果园经营权出租',
          description: '110.91立方/20年/卢龙县',
          price: '¥180万元',
          lng: 118.9,
          lat: 39.8
        },
        {
          title: '秦皇岛开发区工业用土转让',
          description: '15.5立方/50年/开发区',
          price: '¥1200万元',
          lng: 119.5,
          lat: 39.9
        },
        {
          title: '秦皇岛海港区商服用土供应',
          description: '25.8立方/40年/海港区',
          price: '¥2000万元',
          lng: 119.6,
          lat: 39.9
        },
        {
          title: '秦皇岛山海关区林地出租',
          description: '230.07立方/10年/山海关区',
          price: '¥1000元/立方/年',
          lng: 119.8,
          lat: 40.1
        }
      ];
      
      // 计算距离并筛选结果
      this.mapResults = landData.map(land => {
        const distance = this.calculateDistance(
          this.mapCenter.lng, this.mapCenter.lat,
          land.lng, land.lat
        );
        return {
          ...land,
          distance: distance.toFixed(1)
        };
      }).filter(result => 
        parseFloat(result.distance) <= parseInt(this.selectedDistance)
      );
    },
    calculateDistance(lng1, lat1, lng2, lat2) {
      // 使用Haversine公式计算两点间距离（公里）
      const R = 6371; // 地球半径（公里）
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    selectMapResult(result) {
      console.log('选择地图结果:', result);
      // 这里可以添加选择结果后的逻辑
    },
    confirmMapSearch() {
      console.log('确认地图搜索，结果数量:', this.mapResults.length);
      this.closeMapModal();
      // 这里可以添加确认搜索后的逻辑，比如更新主列表
    },
    goToLandDetail(index) {
      console.log('查看土方详情:', index);
      // 这里可以添加跳转到土方详情页面的逻辑
    },
    // 表单相关方法
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileChange(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      
      // 检查已上传图片数量
      const remainingSlots = 9 - this.formData.images.length;
      if (remainingSlots <= 0) {
        alert('最多只能上传9张图片');
        return;
      }
      
      // 处理文件
      const filesToProcess = Array.from(files).slice(0, remainingSlots);
      for (const file of filesToProcess) {
        // 检查文件类型
        if (!file.type.match(/^image\/(jpeg|jpg|png|gif)$/)) {
          alert(`文件 ${file.name} 格式不支持，请上传 JPG/JPEG/GIF/PNG 格式的图片`);
          continue;
        }
        
        // 检查文件大小（6MB）
        if (file.size > 6 * 1024 * 1024) {
          alert(`文件 ${file.name} 超过6M，请选择较小的图片`);
          continue;
        }
        
        // 先本地预览占位
        let placeholderIndex = -1;
        await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.formData.images.push({
              file,
              url: e.target.result, // 临时预览
              name: file.name,
              fileName: '', // 保存fileName
              uploaded: false
            });
            placeholderIndex = this.formData.images.length - 1;
            resolve();
          };
          reader.readAsDataURL(file);
        });

        // 调用上传接口，拿到fileName后拼接完整路径用于回显，但只保存fileName
        try {
          const formData = new FormData();
          formData.append('file', file);
          const res = await uploadFile(formData);
          // 获取fileName（后端返回可能是 res.fileName, res.data.fileName 等）
          let fileName = '';
          if (typeof res === 'string') {
            fileName = res;
          } else if (res && typeof res === 'object') {
            fileName = res.fileName || (res.data && res.data.fileName) || res.url || (res.data && res.data.url) || '';
          }
          
          if (fileName && placeholderIndex > -1) {
            // 拼接完整路径用于回显
            const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
            const fullUrl = fileName.startsWith('http') ? fileName : imageBaseUrl + fileName;
            // 保存fileName用于提交，fullUrl用于回显
            this.formData.images[placeholderIndex].fileName = fileName;
            this.formData.images[placeholderIndex].url = fullUrl;
            this.formData.images[placeholderIndex].uploaded = true;
          }
        } catch (err) {
          console.error('图片上传失败:', err);
          alert(`图片 ${file.name} 上传失败`);
          // 失败移除占位
          if (placeholderIndex > -1) {
            this.formData.images.splice(placeholderIndex, 1);
          }
        }
      }
      
      // 清空input，允许重复选择同一文件
      event.target.value = '';
    },
    removeImage(index) {
      this.formData.images.splice(index, 1);
    },
    // 获取图片URL（确保返回完整的可访问URL）
    getImageUrl(image) {
      if (!image) return '';
      
      // 如果 image 是字符串，直接处理
      if (typeof image === 'string') {
        if (image.startsWith('http') || image.startsWith('data:')) {
          return image;
        }
        if (image.startsWith('/upload/')) {
          // 去掉开头的 /upload，然后拼接 /upload/qtzp/
          const pathAfterUpload = image.replace(/^\/upload\//, '');
          return `https://qtzp.qhdbigdata.com/qtzp-api/upload/${pathAfterUpload}`;
        }
        if (image.startsWith('/')) {
          return `https://qtzp.qhdbigdata.com/qtzp-api/upload${image}`;
        }
        return `https://qtzp.qhdbigdata.com/qtzp-api/upload/${image}`;
      }
      
      // 如果 image 是对象
      if (typeof image === 'object') {
        let url = image.url || image.fileName || '';
        if (!url) return '';
        
        // 如果已经是完整URL，直接返回
        if (url.startsWith('http') || url.startsWith('data:')) {
          return url;
        }
        
        // 如果是相对路径，拼接完整URL
        if (url.startsWith('/upload/')) {
          // 去掉开头的 /upload，然后拼接 /upload/qtzp/
          const pathAfterUpload = url.replace(/^\/upload\//, '');
          return `https://qtzp.qhdbigdata.com/qtzp-api/upload/${pathAfterUpload}`;
        }
        if (url.startsWith('/')) {
          return `https://qtzp.qhdbigdata.com/qtzp-api/upload${url}`;
        }
        
        // 否则使用标准路径
        return `https://qtzp.qhdbigdata.com/qtzp-api/upload/${url}`;
      }
      
      return '';
    },
    // 图片加载错误处理
    handleImageError(event, index) {
      console.error('图片加载失败:', event.target.src, '索引:', index);
      // 可以在这里添加错误处理逻辑，比如显示占位图
    },
    /** 将接口或旧表单中的日期规范为 YYYY-MM，供 type="month" 使用 */
    normalizeMonthValue(val) {
      if (val == null || val === '') return '';
      const s = String(val).trim();
      if (/^\d{4}-\d{2}$/.test(s)) return s;
      const m = s.match(/^(\d{4}-\d{2})/);
      return m ? m[1] : '';
    },
    async submitForm() {
      // 表单验证
      if (!this.formData.region) {
        alert('请选择所在地区');
        return;
      }
      
      if (!this.formData.area) {
        alert('请输入土方体积');
        return;
      }
      
      if (!this.formData.title) {
        alert('请输入信息标题');
        return;
      }
      
      if (!this.formData.description) {
        alert('请输入土详细信息');
        return;
      }
      
      if (!this.formData.contactName) {
        alert('请输入土联系人');
        return;
      }
      
      if (!this.formData.contactPhone) {
        alert('请输入联系人电话');
        return;
      }
      
      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.formData.contactPhone)) {
        alert('请输入正确的手机号码');
        return;
      }

      // 社会统一代码（必填）：18 位统一社会信用代码格式（GB/T 32100 常用字符集）
      const creditRaw = (this.formData.creditCode || '').trim().replace(/\s/g, '');
      if (!creditRaw) {
        alert('请输入社会统一代码');
        return;
      }
      const creditUpper = creditRaw.toUpperCase();
      const creditCodeRegex = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (!creditCodeRegex.test(creditUpper)) {
        alert('社会统一代码格式不正确，请输入18位统一社会信用代码');
        return;
      }
      this.formData.creditCode = creditUpper;

      const projectCodeTrim = (this.formData.projectCode || '').trim();
      if (!projectCodeTrim) {
        alert('请输入项目代码');
        return;
      }
      this.formData.projectCode = projectCodeTrim;

      const companyNameTrim = (this.formData.companyName || '').trim();
      if (!companyNameTrim) {
        alert('请输入建设单位名称');
        return;
      }
      this.formData.companyName = companyNameTrim;

      const projectNameTrim = (this.formData.projectName || '').trim();
      if (!projectNameTrim) {
        alert('请输入项目名称');
        return;
      }
      this.formData.projectName = projectNameTrim;
      
      // 验证 infoType 必填
      // 统一处理 val 的类型（可能是字符串或数字）
      const valStr = String(this.val);
      
      // 强制设置 infoType：根据 val prop 设置默认值（从找土/弃土页面跳转时必须有值）
      if (valStr === '1' || this.val === 1) {
        // 从找土页面跳转，强制设置为找土
        this.infoType = '1';
        console.log('从找土页面发布，强制设置 infoType = 1');
      } else if (valStr === '2' || this.val === 2) {
        // 从弃土页面跳转，强制设置为弃土
        this.infoType = '0';
        console.log('从弃土页面发布，强制设置 infoType = 0');
      } else if (valStr === '0' || this.val === 0) {
        // 从首页弹窗，必须手动选择
        if (!this.infoType || this.infoType === '') {
          this.showInfoTypeError = true;
          // 滚动到错误位置
          this.$nextTick(() => {
            try {
              const errorElement = this.$el?.querySelector?.('.draft-link-group') || 
                                   document.querySelector('.draft-link-group');
              if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            } catch (e) {
              console.warn('无法滚动到错误位置:', e);
            }
          });
          return;
        }
      } else {
        // 其他情况，如果 infoType 为空，提示错误
        if (!this.infoType || this.infoType === '') {
          alert('请选择信息类型（找土或弃土）');
          return;
        }
      }
      
      console.log('提交时 infoType 值:', this.infoType, 'val:', this.val, 'valStr:', valStr);
      
      // 验证 infoType 的值是否有效（必须是 '0' 或 '1'）
      if (this.infoType !== '0' && this.infoType !== '1') {
        // 如果 val 是 '1' 或 '2'，强制设置正确的值
        if (valStr === '1' || this.val === 1) {
          this.infoType = '1';
        } else if (valStr === '2' || this.val === 2) {
          this.infoType = '0';
        } else if (valStr === '0' || this.val === 0) {
          this.showInfoTypeError = true;
          this.$nextTick(() => {
            try {
              const errorElement = this.$el?.querySelector?.('.draft-link-group') || 
                                   document.querySelector('.draft-link-group');
              if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            } catch (e) {
              console.warn('无法滚动到错误位置:', e);
            }
          });
          return;
        } else {
          alert('请选择信息类型（找土或弃土）');
          return;
        }
      }
      
      // 验证通过，清除错误提示
      this.showInfoTypeError = false;
      
      // 构造接口所需字段
      const lnglat = (this.mapCenter && this.mapCenter.lng) ? this.mapCenter : null;
      // 只保存fileName，不存完整URL
      const imageFileNames = (this.formData.images || [])
        .map(i => i && i.fileName)
        .filter(f => typeof f === 'string' && f.trim())
        .join(',');

      const payload = {
        region: this.formData.region || '',
        longitude: lnglat ? lnglat.lng : '',
        latitude: lnglat ? lnglat.lat : '',
        address: this.formData.detailAddress || '',
        volume: this.formData.area ? Number(this.formData.area) : 0,
        volumeUnit: '万m³',
        imageUrl: imageFileNames, // 只保存fileName，多个用逗号分隔
        title: this.formData.title || '',
        detail: this.formData.description || '',
        contactPhone: this.formData.contactPhone || '',
        contactName: this.formData.contactName || '',
        startTime: this.formData.startTime || '',
        endTime: this.formData.endTime || '',
        soilType: this.formData.soilType || '',//土方类型
        application: this.formData.application || '',
        creditCode: this.formData.creditCode || '',
        projectCode: this.formData.projectCode || '',
        companyName: this.formData.companyName || '',
        projectName: this.formData.projectName || '',
        infoType: String(this.infoType), // 确保是字符串类型：'0'弃土，'1'找土
        infoStatus: 0,
        delFlag: 0
      };

      try {
        // 判断是编辑模式还是新增模式
        // 优先级：editId (从编辑弹窗传入) > draftLoadedId (从暂存列表加载)
        const idToUpdate = this.editId || this.draftLoadedId;
        
        if (idToUpdate) {
          // 编辑模式，调用更新接口
          payload.id = idToUpdate;
          await updateSoilInfo(payload);
          alert('内容重新编辑后，需提交再次审核，审核通过方可再次发布');
          // 清除暂存加载的 id
          this.draftLoadedId = null;
        } else {
          // 新增模式，调用新增接口
          await addSoilInfo(payload);
          alert('提交成功！审核将在 1-3 个工作日内完成，请留意系统通知。');
        }
        // 通知父级关闭弹窗
        this.$emit('close');
        // 触发成功事件
        this.$emit('success');
        // this.resetForm();
      } catch (e) {
        const isEdit = this.editId || this.draftLoadedId;
        console.error(isEdit ? '修改失败' : '发布失败', e);
        alert(isEdit ? '修改失败，请稍后再试' : '发布失败，请稍后再试');
      }
    },
    resetForm() {
      this.formData = {
        region: '',
        mapLocation: '',
        detailAddress: '',
        startTime: '',
        endTime: '',
        soilType: '',
        area: '',
        areaUnit: '万m³',
        transferType: '经营权出租',
        price: '',
        priceUnit: '元',
        years: '',
        images: [],
        title: '',
        description: '',
        contactName: '',
        contactPhone: '',
        creditCode: '',
        projectCode: '',
        companyName: '',
        projectName: ''
      };
      // 重置 infoType，但保留 val 设置的默认值
      const valStr = String(this.val);
      if (valStr === '1') {
        this.infoType = '1'; // 找土
      } else if (valStr === '2') {
        this.infoType = '0'; // 弃土
      } else {
        this.infoType = '';
      }
      // 清除暂存加载的 id
      this.draftLoadedId = null;
    },
    async initDisplayMap() {
      await this.loadAmapScript();
      
      const container = document.getElementById('amap-display-container');
      if (!container) {
        console.error('地图容器未找到');
        return;
      }
      
      // 解析坐标
      const coords = this.formData.mapLocation.split(',').map(c => parseFloat(c.trim()));
      if (coords.length !== 2 || isNaN(coords[0]) || isNaN(coords[1])) {
        console.error('坐标格式错误');
        return;
      }
      
      const [lng, lat] = coords;
      
      // 如果地图已存在，只更新标记
      if (this.displayMap) {
        // 清除旧标记
        if (this.displayMarker) {
          this.displayMap.remove(this.displayMarker);
        }
        
        // 添加新标记
        this.addDisplayMarker(lng, lat);
        this.displayMap.setCenter([lng, lat]);
      } else {
        // 创建新地图
        this.displayMap = new AMap.Map('amap-display-container', {
          zoom: 13,
          center: [lng, lat],
          mapStyle: 'amap://styles/normal'
        });
        
        // 添加标记
        this.addDisplayMarker(lng, lat);
      }
    },
    addDisplayMarker(lng, lat) {
      // 创建自定义标记内容（使用icon-1图标）
      const markerContent = document.createElement('div');
      markerContent.className = 'custom-marker';
      markerContent.innerHTML = '<i class="iconfont icon-1" style="font-size: 48px; color: #FF0000; text-shadow: 0 3px 6px rgba(255, 0, 0, 0.4); display: block; line-height: 1;"></i>';
      
      // 创建标记
      this.displayMarker = new AMap.Marker({
        position: [lng, lat],
        content: markerContent,
        offset: new AMap.Pixel(-24, -48)
      });
      
      this.displayMap.add(this.displayMarker);
    },
    
    // 暂存列表相关方法
    toggleDraftList() {
      this.showDraftList = true;
      this.loadDraftList();
    },
    
    closeDraftModal() {
      this.showDraftList = false;
      this.selectedDraftId = null;
    },
    
    async loadDraftList() {
      try {
        // 调用接口获取暂存列表（infoStatus: 3）
        const res = await getMySoilInfoList({ infoStatus: 3 });
        console.log('暂存列表接口返回:', res);
        
        // 适配不同的返回格式
        let list = [];
        if (res) {
          // 格式1: { rows: [...] }
          if (res.rows && Array.isArray(res.rows)) {
            list = res.rows;
          }
          // 格式2: { data: { rows: [...] } }
          else if (res.data && res.data.rows && Array.isArray(res.data.rows)) {
            list = res.data.rows;
          }
          // 格式3: { data: [...] }
          else if (res.data && Array.isArray(res.data)) {
            list = res.data;
          }
          // 格式4: { code: 200, data: [...] }
          else if (res.code === 200 && res.data) {
            if (Array.isArray(res.data)) {
              list = res.data;
            } else if (res.data.rows && Array.isArray(res.data.rows)) {
              list = res.data.rows;
            }
          }
          // 格式5: 直接返回数组
          else if (Array.isArray(res)) {
            list = res;
          }
        }
        
        // 将接口返回的数据转换为暂存列表格式
        this.draftList = list.map(item => ({
          id: item.id || String(Date.now() + Math.random()),
          region: item.region || '',
          mapLocation: item.longitude && item.latitude ? `${item.longitude},${item.latitude}` : '',
          detailAddress: item.address || '',
          startTime: item.startTime || '',
          endTime: item.endTime || '',
          area: item.volume ? String(item.volume) : '',
          areaUnit: '万m³',
          transferType: item.transferType || '经营权出租',
          price: item.price ? String(item.price) : '',
          priceUnit: item.priceUnit || '元',
          years: item.years || '',
          images: item.imageUrl ? item.imageUrl.split(',').filter(url => url.trim()).map(url => ({
            url: url.startsWith('http') ? url : `https://qtzp.qhdbigdata.com/qtzp-api/upload/${url}`,
            fileName: url.split('/').pop() || url
          })) : [],
          title: item.title || '',
          description: item.detail || '',
          contactName: item.contactName || '',
          contactPhone: item.contactPhone || '',
          creditCode: item.creditCode || '',
          projectCode: item.projectCode || '',
          companyName: item.companyName || '',
          projectName: item.projectName || '',
          createTime: item.createTime || item.updateTime || new Date().toISOString(),
          updateTime: item.updateTime || item.createTime || new Date().toISOString(),
          infoType: item.infoType !== undefined && item.infoType !== null ? String(item.infoType) : ''
        }));
        
        this.filteredDrafts = [...this.draftList];
        this.sortDrafts();
      } catch (error) {
        console.error('获取暂存列表失败:', error);
        // 如果接口调用失败，使用空数组
        this.draftList = [];
        this.filteredDrafts = [];
      }
    },
    
    getMockDraftData() {
      const now = new Date();
      return [
      
        {
          id: '4',
          region: '卢龙县',
          mapLocation: '118.945678, 39.745678',
          detailAddress: '秦皇岛市卢龙县卢龙镇101号',
          area: '110.91',
          areaUnit: '万m³',
          transferType: '经营权合作',
          price: '180',
          priceUnit: '万元',
          years: '20',
          images: [],
          title: '卢龙县果园土方供应信息',
          description: '卢龙县优质土方资源，土壤肥沃，质地优良，气候适宜。适合发展现代农业、生态农业项目的土方需求，具有良好的经济效益。',
          contactName: '刘老板',
          contactPhone: '13654321087',
          createTime: '7小时前', // 7天前
          updateTime: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString()
        },
        {
          id: '5',
          region: '山海关区',
          mapLocation: '119.756789, 40.056789',
          detailAddress: '秦皇岛市山海关区关城路202号',
          area: '230.07',
          areaUnit: '万m³',
          transferType: '经营权入股',
          price: '1000',
          priceUnit: '元/立方/年',
          years: '10',
          images: [],
          title: '山海关区林地土方供应信息',
          description: '山海关区大体积土方资源，生态环境优美，质地优良，适合发展生态旅游、林业种植等项目的土方需求。投资回报稳定。',
          contactName: '陈经理',
          contactPhone: '13543210976',
          createTime: '8小时前', // 7天前
          updateTime: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString()
        },
        {
          id: '6',
          region: '北戴河区',
          mapLocation: '119.467890, 39.867890',
          detailAddress: '秦皇岛市北戴河区海滨路303号',
          area: '12.3',
          areaUnit: '万m³',
          transferType: '经营权互换',
          price: '1500',
          priceUnit: '万元',
          years: '30',
          images: [],
          title: '北戴河区旅游土方供应信息',
          description: '北戴河区优质土方资源，临近海滨，风景优美，质地优良。适合建设度假村、酒店等旅游配套设施的土方需求。',
          contactName: '赵总',
          contactPhone: '13432109865',
          createTime: '9小时前', // 7天前
          updateTime: new Date(now.getTime() - 4 * 60 * 60 * 1000).toISOString()
        }
      ];
    },
    
    saveDraftList() {
      // 保存暂存列表到localStorage
      localStorage.setItem('draftList', JSON.stringify(this.draftList));
    },
    
    async saveDraft() {
      // 基本验证
      if (!this.formData.title && !this.formData.region && !this.formData.area) {
        alert('请至少填写标题、地区或体积中的一项才能暂存');
        return;
      }
      
      // 验证 infoType 必填
      // 统一处理 val 的类型（可能是字符串或数字）
      const valStr = String(this.val);
      
      // 强制设置 infoType：根据 val prop 设置默认值（从找土/弃土页面跳转时必须有值）
      if (valStr === '1' || this.val === 1) {
        // 从找土页面跳转，强制设置为找土
        this.infoType = '1';
      } else if (valStr === '2' || this.val === 2) {
        // 从弃土页面跳转，强制设置为弃土
        this.infoType = '0';
      } else if (valStr === '0' || this.val === 0) {
        // 从首页弹窗，必须手动选择
        if (!this.infoType || this.infoType === '') {
          alert('请选择信息类型（找土或弃土）');
          return;
        }
      } else {
        // 其他情况，如果 infoType 为空，提示错误
        if (!this.infoType || this.infoType === '') {
          alert('请选择信息类型（找土或弃土）');
          return;
        }
      }
      
      // 验证 infoType 的值是否有效（必须是 '0' 或 '1'）
      if (this.infoType !== '0' && this.infoType !== '1') {
        // 如果 val 是 '1' 或 '2'，强制设置正确的值
        if (valStr === '1' || this.val === 1) {
          this.infoType = '1';
        } else if (valStr === '2' || this.val === 2) {
          this.infoType = '0';
        } else {
          alert('请选择信息类型（找土或弃土）');
          return;
        }
      }
      
      // 构造接口所需字段
      const lnglat = (this.mapCenter && this.mapCenter.lng) ? this.mapCenter : null;
      // 只保存fileName，不存完整URL
      const imageFileNames = (this.formData.images || [])
        .map(i => i && i.fileName)
        .filter(f => typeof f === 'string' && f.trim())
        .join(',');
      
      const payload = {
        region: this.formData.region || '',
        longitude: lnglat ? lnglat.lng : '',
        latitude: lnglat ? lnglat.lat : '',
        address: this.formData.detailAddress || '',
        volume: this.formData.area ? Number(this.formData.area) : 0,
        volumeUnit: '万m³',
        imageUrl: imageFileNames, // 只保存fileName，多个用逗号分隔
        title: this.formData.title || '',
        detail: this.formData.description || '',
        contactPhone: this.formData.contactPhone || '',
        contactName: this.formData.contactName || '',
        startTime: this.formData.startTime || '',
        endTime: this.formData.endTime || '',
        soilType: this.formData.soilType || '',//土方类型
        application: this.formData.application || '',
        creditCode: this.formData.creditCode || '',
        projectCode: this.formData.projectCode || '',
        companyName: this.formData.companyName || '',
        projectName: this.formData.projectName || '',
        infoType: String(this.infoType), // 确保是字符串类型：'0'弃土，'1'找土
        infoStatus: 3, // 暂存状态
        delFlag: 0
      };
      
      try {
        // 如果已存在 id（从暂存列表加载的），调用编辑接口；否则调用新增接口
        if (this.draftLoadedId) {
          // 编辑模式，调用更新接口，保持 infoStatus: 3 暂存状态
          payload.id = this.draftLoadedId;
          await updateSoilInfo(payload);
          alert('暂存成功！');
        } else {
          // 新增模式，调用新增接口，传入 infoStatus: 3 表示暂存
          const res = await addSoilInfo(payload);
          alert('暂存成功！');
          
          // 尝试从响应中获取 id，以便下次暂存时调用编辑接口
          // 适配不同的返回格式
          let newId = null;
          if (res) {
            if (res.id) {
              newId = res.id;
            } else if (res.data && res.data.id) {
              newId = res.data.id;
            } else if (res.data && typeof res.data === 'number') {
              newId = res.data;
            } else if (typeof res === 'number') {
              newId = res;
            }
          }
          
          // 如果获取到 id，保存到 draftLoadedId，以便下次暂存时调用编辑接口
          if (newId) {
            this.draftLoadedId = String(newId);
            console.log('暂存成功，已保存 id:', this.draftLoadedId);
          }
        }
        // 重新加载暂存列表
        await this.loadDraftList();
      } catch (e) {
        console.error('暂存失败', e);
        const errorMsg = e?.response?.data?.msg || e?.message || '暂存失败，请稍后再试';
        alert(errorMsg);
      }
    },
    
    selectDraft(draft) {
      this.selectedDraftId = draft.id;
    },
    
    loadDraftToForm() {
      if (!this.selectedDraftId) {
        alert('请先选择一个暂存项');
        return;
      }
      
      const draft = this.draftList.find(d => d.id === this.selectedDraftId);
      if (draft) {
        // 保存暂存项的 id，用于提交时判断是新增还是编辑
        this.draftLoadedId = draft.id;
        
        // 将暂存数据加载到表单
        this.formData = {
          region: draft.region || '',
          mapLocation: draft.mapLocation || '',
          detailAddress: draft.detailAddress || '',
          startTime: this.normalizeMonthValue(draft.startTime || ''),
          endTime: this.normalizeMonthValue(draft.endTime || ''),
          area: draft.area || '',
          areaUnit: '万m³',
          transferType: draft.transferType || '经营权出租',
          price: draft.price || '',
          priceUnit: draft.priceUnit || '元/立方/年',
          years: draft.years || '',
          images: draft.images || [],
          title: draft.title || '',
          description: draft.description || '',
          contactName: draft.contactName || '',
          contactPhone: draft.contactPhone || '',
          creditCode: draft.creditCode || '',
          projectCode: draft.projectCode || '',
          companyName: draft.companyName || '',
          projectName: draft.projectName || ''
        };
        
        // 如果有 infoType，也设置到表单
        if (draft.infoType !== undefined && draft.infoType !== null && draft.infoType !== '') {
          this.infoType = String(draft.infoType);
        }
        
        // 如果有地图位置，初始化显示地图
        if (this.formData.mapLocation) {
          this.$nextTick(() => {
            // 解析坐标并设置地图中心
            const coords = this.formData.mapLocation.split(',').map(c => parseFloat(c.trim()));
            if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
              this.mapCenter = { lng: coords[0], lat: coords[1] };
              this.initDisplayMap();
            }
          });
        }
        
        // 关闭暂存列表弹窗
        this.closeDraftModal();
        alert('已加载到表单！');
      }
    },
    
    editDraft(draft) {
      // 加载到表单进行编辑
      this.selectedDraftId = draft.id;
      this.loadDraftToForm();
    },
    
    async deleteDraft(draftId) {
      if (!confirm('确定要删除这个暂存项吗？')) {
        return;
      }
      
      try {
        // 调用删除接口
        await removeSoilInfo(draftId);
        alert('删除成功！');
        
        // 清除选中的暂存项
        if (this.selectedDraftId === draftId) {
          this.selectedDraftId = null;
        }
        
        // 重新加载暂存列表
        await this.loadDraftList();
      } catch (error) {
        console.error('删除暂存失败:', error);
        const errorMsg = error?.response?.data?.msg || error?.message || '删除失败，请稍后再试';
        alert(errorMsg);
      }
    },
    
    sortDrafts() {
      if (!this.filteredDrafts || !Array.isArray(this.filteredDrafts)) {
        this.filteredDrafts = [];
        return;
      }
      
      const drafts = [...this.filteredDrafts];
      
      switch (this.draftSortBy) {
        case 'time-desc':
          drafts.sort((a, b) => new Date(b.createTime) - new Date(a.createTime));
          break;
        case 'time-asc':
          drafts.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
          break;
        case 'title-asc':
          drafts.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
          break;
        case 'title-desc':
          drafts.sort((a, b) => (b.title || '').localeCompare(a.title || ''));
          break;
      }
      
      this.filteredDrafts = drafts;
    },
    
    filterDrafts() {
      if (!this.draftList || !Array.isArray(this.draftList)) {
        this.filteredDrafts = [];
        return;
      }
      
      if (!this.draftSearchKeyword.trim()) {
        this.filteredDrafts = [...this.draftList];
      } else {
        const keyword = this.draftSearchKeyword.toLowerCase();
        this.filteredDrafts = this.draftList.filter(draft => 
          (draft.title && draft.title.toLowerCase().includes(keyword)) ||
          (draft.region && draft.region.toLowerCase().includes(keyword)) ||
          (draft.description && draft.description.toLowerCase().includes(keyword))
        );
      }
      this.sortDrafts();
    },
    
    formatTime(timeString) {
      const date = new Date(timeString);
      const now = new Date();
      const diff = now - date;
      
      if (diff < 60000) { // 1分钟内
        return '刚刚';
      } else if (diff < 3600000) { // 1小时内
        return Math.floor(diff / 60000) + '分钟前';
      } else if (diff < 86400000) { // 1天内
        return Math.floor(diff / 3600000) + '小时前';
      } else if (diff < 604800000) { // 1周内
        return Math.floor(diff / 86400000) + '天前';
      } else {
        return date.toLocaleDateString('zh-CN');
      }
    }
    }
}
</script>

  <style scoped>
  @import url('../assets/iconfont.css');
  
  .land-supply-page {
    /* background: #f5f5f5; */
    min-height: 100vh;
    /* padding: 20px 0; */
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    overflow: visible;
  }

  /* 表单容器 */
  .form-wrapper {
    background: white;
    border-radius: 12px;
    /* box-shadow: 0 2px 12px rgba(0,0,0,0.1); */
    padding: 30px;
    margin: 0 0 20px 0;
    position: relative;
    overflow: visible;
  }

  .form-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 0 0 30px 0;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
  }

  /* 表单组 */
  .form-group {
    margin-bottom: 25px;
    display: flex;
    align-items: flex-start;
    position: relative;
  }

  /* 表单组行（用于并排显示） */
  .form-group-row {
    margin-bottom: 25px;
    display: flex;
    gap: 20px;
  }

  .form-group-item {
    flex: 1;
    display: flex;
    align-items: flex-start;
  }

  .form-group-item .form-label {
    width: 120px;
    padding-top: 10px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    flex-shrink: 0;
    text-align: right;
    margin-right: 20px;
  }

  .form-group-item .form-control {
    flex: 1;
  }

  .form-label {
    width: 120px;
    padding-top: 10px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    flex-shrink: 0;
    text-align: right;
    margin-right: 20px;
  }

  .required {
    color: #ff4d4f;
    margin-right: 4px;
  }

  .form-control {
    flex: 1;
    position: relative;
    overflow: visible;
  }

  /* 输入框 */
  .input-text {
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
    box-sizing: border-box;
  }

  .input-text:hover {
    border-color: #40a9ff;
  }

  .input-text:focus {
    border-color: #FFA500;
    box-shadow: 0 0 0 2px rgba(255, 165, 0, 0.1);
  }

  .input-text.full-width {
    width: 100%;
  }

  /* 文本域 */
  .input-textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
    box-sizing: border-box;
    resize: vertical;
    font-family: inherit;
    line-height: 1.5;
  }

  .input-textarea:hover {
    border-color: #40a9ff;
  }

  .input-textarea:focus {
    border-color: #FFA500;
    box-shadow: 0 0 0 2px rgba(255, 165, 0, 0.1);
  }

  .input-tip {
    margin: 8px 0 0 0;
    font-size: 12px;
    color: #FFA500;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .input-tip i {
    font-size: 14px;
  }

  /* 下拉框 */
  .input-select {
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    cursor: pointer;
    background: white;
    transition: border-color 0.3s;
    box-sizing: border-box;
  }

  .input-select:hover {
    border-color: #40a9ff;
  }

  .input-select:focus {
    border-color: #FFA500;
    box-shadow: 0 0 0 2px rgba(255, 165, 0, 0.1);
  }

  .input-select.full-width {
    width: 100%;
  }

  /* 地区选择器 */
  .region-selector {
    width: 100%;
  }

  .filter-item {
    position: relative;
    cursor: pointer;
    width: 100%;
  }

  .filter-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    color: #333;
    font-weight: 400;
    padding: 10px 15px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    transition: all 0.2s ease;
    background: white;
    min-height: 40px;
    box-sizing: border-box;
  }

  .filter-item:hover .filter-label {
    border-color: #333;
    background-color: #E4CEC2;
    border:0
  }

  .filter-label .current-value {
    color: #422C27;
    font-weight: 500;
    flex: 1;
    text-align: left;
  }

  /* 下拉选项框 */
  .filter-dropdown {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 100;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    background: white;
    padding: 15px;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    margin-top: 2px;
    width: 100%;
    max-width: 100%;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
  }

  .filter-option {
    display: inline-block;
    padding: 6px 18px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
  }

  .filter-option:hover {
    color: #333;
    background: #E4CEC2;
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(14, 133, 117, 0.2);
  }

  .filter-option.active {
    border-color: #422C27;
    background: #422C27;
    color: white;
    font-weight: 500;
  }

  /* 地图控制 */
  .map-control {
    display: flex;
    gap: 10px;
  }

  .map-control .input-text {
    flex: 1;
  }

  .mark-btn {
    height: 40px;
    padding: 0 20px;
    background: white;
    color: #1890ff;
    border: 1px solid #1890ff;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.3s;
  }

  .mark-btn:hover {
    background: #1890ff;
    color: white;
  }

  /* 体积控制 */
  .area-control {
    display: flex;
    gap: 10px;
  }

  .area-input {
    flex: 1;
  }

  .unit-select {
    width: 120px;
  }

  .unit-fixed {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    flex-shrink: 0;
    color: #333;
  }

  .datetime-input {
    position: relative;
    z-index: 2;
    background: white;
  }

  .datetime-input::-webkit-calendar-picker-indicator {
    cursor: pointer;
    font-size: 16px;
  }

  /* 确保日期选择弹窗不被遮挡 */
  .time-range-group {
    position: relative;
    z-index: 10;
    overflow: visible;
  }

  .time-range-group .form-control {
    overflow: visible;
  }

  /* 流转类型 */
  .transfer-types {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .type-btn {
    padding: 8px 20px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background: white;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
  }

  .type-btn:hover {
    border-color: #FFA500;
    color: #FFA500;
  }

  .type-btn.active {
    background: #FFA500;
    border-color: #FFA500;
    color: white;
  }

  /* 价格控制 */
  .price-control {
    display: flex;
    gap: 10px;
  }

  .price-input {
    flex: 1;
  }

  /* 年限控制 */
  .year-control {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .year-input {
    flex: 1;
  }

  .unit-text {
    font-size: 14px;
    color: #666;
  }

  /* 上传区域 */
  .upload-area {
    /* border: 1px dashed #d9d9d9; */
    border-radius: 4px;
    /* background: #fafafa; */
    cursor: pointer;
    transition: border-color 0.3s;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 10px;
  }

  /* .upload-area:hover {
    border-color: #FFA500;
  } */

  .upload-placeholder {
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background: #fff;
    color: #999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .upload-placeholder i {
    font-size: 28px;
    color: #d9d9d9;
    display: block;
    margin-bottom: 8px;
  }

  .upload-placeholder p {
    margin: 0;
    font-size: 12px;
  }

  .upload-tip {
    margin: 8px 0 0 0;
    font-size: 12px;
    color: #FFA500;
  }

  /* 图片预览 */
  .image-preview-list {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    padding: 0;
  }

  .image-preview-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #d9d9d9;
  }

  .image-preview-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .remove-image-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s;
    z-index: 10;
    padding: 0;
    line-height: 1;
  }

  .remove-image-btn .close-icon {
    color: white;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    display: block;
    margin: 0;
    padding: 0;
  }

  .remove-image-btn:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .remove-image-btn:hover .close-icon {
    color: white;
  }


  .add-more-btn {
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fff;
    transition: all 0.3s;
  }

  .add-more-btn:hover {
    border-color: #FFA500;
    background: #fff7e6;
  }

  .add-more-btn i {
    font-size: 24px;
    color: #999;
  }

  /* 表单操作 */
  .form-actions {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    gap: 15px;
    justify-content: center;
  }

  .submit-btn {
    padding: 10px 40px;
    background: #381E1D;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;
  }

  .submit-btn:hover {
    background: #E4CEC2;
    color: #381E1D;
  }
.submit-btn1 {
    padding: 10px 40px;
    background: #fff;
    color: #666;
    border: 1px solid #381E1D;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;
  }
  .submit-btn1:hover {
    background: #E4CEC2;
    border-color: #E4CEC2;
  }
  .cancel-btn {
    padding: 10px 40px;
    background: white;
    color: #666;
    border: 1px solid #381E1D;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }

  .cancel-btn:hover {
    background: #E4CEC2;
    border-color: #E4CEC2;

  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .form-wrapper {
      padding: 20px;
    }

    .form-group {
      flex-direction: column;
    }

    .form-group-row {
      flex-direction: column;
      gap: 15px;
    }

    .form-group-item {
      flex-direction: column;
    }

    .form-label {
      width: 100%;
      padding-top: 0;
      margin-bottom: 8px;
    }

    .form-group-item .form-label {
      width: 100%;
      padding-top: 0;
      margin-bottom: 8px;
    }

    .transfer-types {
      gap: 8px;
    }

    .type-btn {
      padding: 6px 12px;
      font-size: 13px;
    }

    .form-actions {
      flex-direction: column;
    }

    .submit-btn,
    .cancel-btn {
      width: 100%;
    }
  }

  /* 页面标题 */
  .page-header {
    text-align: center;
    margin-bottom: 30px;
    padding: 40px 0;
    background: linear-gradient(135deg, #422C27 0%, #0d6b5f 100%);
    border-radius: 12px;
    color: white;
  }

  .page-title {
    font-size: 36px;
    font-weight: bold;
    margin: 0 0 15px 0;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }

  .page-subtitle {
    font-size: 16px;
    margin: 0;
    opacity: 0.9;
  }

  /* 搜索栏 */
  .search-section {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin-bottom: 20px;
    padding: 20px;
  }

  .search-bar {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .search-input {
    flex: 1;
    height: 45px;
    padding: 0 20px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s ease;
  }

  .search-input:focus {
    border-color: #422C27;
  }

  .search-btn {
    height: 45px;
    padding: 0 25px;
    background: #FFA500;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .search-btn:hover {
    background: #FF8C00;
  }

  .map-btn {
    height: 45px;
    padding: 0 25px;
    background: #422C27;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .map-btn:hover {
    background: #0d6b5f;
  }

  /* 筛选栏 */
  .filter-section {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin-bottom: 20px;
    padding: 15px 20px;
  }

  .filter-bar {
    display: flex;
    gap: 15px;
    align-items: center;
    flex-wrap: wrap;
  }

  .filter-select {
    height: 40px;
    padding: 0 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background: white;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s ease;
    min-width: 100px;
  }

  .filter-select:focus {
    border-color: #422C27;
  }

  /* 土方列表 */
  .land-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .land-item {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
  }

  .land-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .land-image {
    position: relative;
    width: 300px;
    height: 200px;
    flex-shrink: 0;
  }

  .land-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .guarantee-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    background: #FF6B35;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .watermark {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-weight: 500;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
  }

  .land-details {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
  }

  .land-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 15px 0;
    line-height: 1.4;
  }

  .land-tags {
    margin-bottom: 15px;
  }

  .tag {
    display: inline-block;
    padding: 4px 12px;
    background: #E3F2FD;
    color: #1976D2;
    border: 1px solid #BBDEFB;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 8px;
    margin-bottom: 5px;
  }

  .land-description {
    font-size: 14px;
    color: #666;
    margin: 0 0 15px 0;
    line-height: 1.5;
  }

  .land-price {
    font-size: 20px;
    font-weight: bold;
    color: #FF6B35;
    margin: 0;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .land-item {
      flex-direction: column;
    }

    .land-image {
      width: 100%;
      height: 200px;
    }

    .search-bar {
      flex-direction: column;
      gap: 10px;
    }

    .search-input {
      width: 100%;
    }

    .search-btn,
    .map-btn {
      width: 100%;
    }

    .filter-bar {
      flex-direction: column;
      align-items: stretch;
    }

  .filter-select {
    width: 100%;
  }
}

/* 地图模态框样式 */
.map-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.map-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background: #eee;
}

.map-controls {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.location-input {
  flex: 1;
  display: flex;
  gap: 10px;
  min-width: 300px;
}

.location-search {
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.location-search:focus {
  border-color: #422C27;
}

.search-location-btn {
  height: 40px;
  padding: 0 20px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.search-location-btn:hover {
  background: #0d6b5f;
}

.distance-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.distance-selector label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

.distance-selector select {
  height: 40px;
  padding: 0 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
}

.map-content {
  height: 400px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.amap-container {
  width: 100%;
  height: 100%;
}

.map-placeholder {
  text-align: center;
  color: #666;
}

.map-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.map-tip {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.map-results {
  max-height: 200px;
  overflow-y: auto;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.map-results h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.result-item:hover {
  background: #e9ecef;
}

.result-info h5 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #333;
}

.result-info p {
  margin: 0 0 5px 0;
  font-size: 12px;
  color: #666;
}

.distance {
  font-size: 12px;
  color: #422C27;
  font-weight: 500;
}

.result-price {
  font-size: 16px;
  font-weight: bold;
  color: #422C27;
}

.map-actions {
  padding: 20px;
  text-align: center;
}

.confirm-btn {
  background: #422C27;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirm-btn:hover:not(:disabled) {
  background: #0d6b5f;
}

.confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .map-container {
    width: 95%;
    margin: 10px;
  }
  
  .map-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .location-input {
    min-width: auto;
  }
  
  .distance-selector {
    justify-content: space-between;
  }
}

/* 地图显示容器样式 */
.amap-display-container {
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

/* 自定义标记样式 */
.custom-marker {
  position: relative;
}

.custom-marker .iconfont {
  font-size: 48px;
  color: #FF0000;
  text-shadow: 0 3px 6px rgba(255, 0, 0, 0.4);
  display: block;
  line-height: 1;
}

.custom-marker .icon-1 {
  animation: marker-bounce 1s ease-in-out;
}

@keyframes marker-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 暂存列表样式 */
.draft-toggle {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.draft-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  margin-right: 10px;
}

.draft-link-group > div:first-child {
  display: flex;
  gap: 10px;
  align-items: center;
}

.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  padding-left: 4px;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.radio-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
}

.radio-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 0;
  height: 0;
}

.radio-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  user-select: none;
}

.radio-label::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #495057;
  border-radius: 50%;
  margin-right: 4px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.radio-option input[type="radio"]:checked + .radio-label {
  background: #422C27;
  border-color: #422C27;
  color: white;
}

.radio-option input[type="radio"]:checked + .radio-label::before {
  border-color: white;
  background: white;
  background-image: radial-gradient(circle, #422C27 40%, transparent 40%);
}

.radio-label:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.radio-option input[type="radio"]:checked + .radio-label:hover {
  background: #422C27;
  border-color: #422C27;
}

.draft-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  margin-left: 10px;
}

.draft-link:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.draft-link.active {
  background: #422C27;
  border-color: #422C27;
  color: white;
}

.draft-count {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 12px;
}

/* 暂存列表弹窗样式 */
.draft-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.draft-modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.draft-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.draft-modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.draft-modal-controls {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.draft-controls {
  display: flex;
  gap: 15px;
  align-items: center;
}

.sort-select {
  height: 36px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  outline: none;
}

.sort-select:focus {
  border-color: #422C27;
}

.search-input {
  height: 36px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  width: 200px;
}

.search-input:focus {
  border-color: #422C27;
}

.draft-modal-content {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  display: block;
}

.draft-items {
  padding: 0;
}

.draft-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s ease;
  gap: 15px;
}

.draft-index {
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: #422C27;
  border: 2px solid #a08681;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.draft-item:hover {
  background: #f8f9fa;
}

.draft-item.selected {
  background: #e3f2fd;
  border-left: 4px solid #422C27;
}

.draft-radio {
  margin-right: 15px;
}

.draft-radio input[type="radio"] {
  margin: 0;
}

.draft-content {
  flex: 1;
  min-width: 0;
}

.draft-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.draft-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #666;
}

.draft-region {
  background: #e3f2fd;
  color: #1976d2;
  padding: 2px 8px;
  border-radius: 4px;
}

.draft-area {
  background: #f3e5f5;
  color: #7b1fa2;
  padding: 2px 8px;
  border-radius: 4px;
}

.draft-time {
  color: #999;
}

.draft-description {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.draft-actions {
  display: flex;
  gap: 8px;
  margin-left: 15px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 14px;
}

.edit-btn {
  background: #e3f2fd;
  color: #1976d2;
}

.edit-btn:hover {
  background: #bbdefb;
}

.delete-btn {
  background: #ffebee;
  color: #d32f2f;
}

.delete-btn:hover {
  background: #ffcdd2;
}

.draft-modal-footer {
  padding: 20px;
  text-align: center;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.load-btn {
  background: #422C27;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.load-btn:hover {
  background: #0d6b5f;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .draft-modal-container {
    width: 95%;
    margin: 10px;
  }
  
  .draft-controls {
    flex-direction: column;
    gap: 10px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .draft-item {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .draft-radio {
    margin-right: 0;
    align-self: flex-start;
  }
  
  .draft-actions {
    margin-left: 0;
    justify-content: flex-end;
  }
  
  .draft-meta {
    flex-wrap: wrap;
    gap: 8px;
  }
}


</style>